export function InternetAcumulada({
  hasInternetAcumulada,
}: {
  hasInternetAcumulada: boolean;
}) {
  if (!hasInternetAcumulada) return null;

  return (
    <img
      className="w-[208px] aspect-auto -ml-2"
      alt="internet acumulada"
      src="/internet-acumulada.png"
    />
  );
}
